<div *ngIf="researchPartner">
	<his-plam key="fs.res.common.organisations.ResearchPartner.business.defaulttext" [required]="true">
		<input #content [(ngModel)]="researchPartner.business.defaulttext" class="inputWidth100"
            (keydown.tab)="$event.preventDefault(); $event.stopPropagation(); cityInput.focus();">
	</his-plam>

	<his-plam key="fs.res.common.organizations.ResearchPartner.business.address.city" [required]="true">
		<input #content #cityInput [(ngModel)]="researchPartnerCity" (ngModelChange)="cityChange($event)" class="inputWidth100"
            (keydown.tab)="$event.stopPropagation(); countryInput.el?.nativeElement?.focus();">
	</his-plam>

	<his-plam key="fs.res.common.organizations.researchPartner.ResearchPartner.business.address.country" [required]="true">
		<p-autoComplete #countryInput #content appendTo="body"
			[(ngModel)]="researchPartnerCountry" (ngModelChange)="countryChange($event)" hisEagerDataSource="country">
		</p-autoComplete>
	</his-plam>

	<div *ngIf="isCountryGermany()">
		<his-plam key="fs.res.common.organizations.researchPartner.ResearchPartner.business.address.district">
			<p-autoComplete #content appendTo="body"
				[(ngModel)]="researchPartnerDistrict" (ngModelChange)="districtChange($event)" hisEagerDataSource="districtValue">
			</p-autoComplete>
		</his-plam>
	</div>
</div>
